import React from 'react';
import { useIntl } from 'react-intl-next';

import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import Button from '@atlaskit/button/new';

import { useChoreographerAssets } from '@confluence/choreographer-services/entry-points/useChoreographerAssets';
import { fg } from '@confluence/feature-gating';

export const ViewPermissionsInfoButton = ({
	content,
	isOpen,
	onClick,
}: {
	content: React.ReactNode;
	isOpen: boolean;
	onClick: () => void;
}) => {
	const { formatMessage } = useIntl();
	const { Popup } = useChoreographerAssets();
	return (
		<>
			<Popup
				isOpen={isOpen}
				content={() => content}
				placement="bottom"
				trigger={(triggerProps) => (
					// eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
					<span {...triggerProps} onClick={onClick}>
						<Button
							appearance="subtle"
							aria-haspopup
							iconBefore={StatusInformationIcon}
							onClick={onClick}
							aria-label={formatMessage({
								id: 'bulk-access.role-select.info-popup',
								description:
									'Aria label for an info button that pops up a description of the selected role permissions',
								defaultMessage: 'View info',
							})}
						>
							{null}
						</Button>
					</span>
				)}
				shouldRenderToParent={fg('should-render-to-parent-should-be-truepermissions')}
			/>
		</>
	);
};
